import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";
import { captureUtmParams } from "./lib/pricing-config";

// Capture inbound utm_* params on landing so they survive client-side nav
// and can be forwarded to the signup handoff URL.
captureUtmParams();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
